import React from "react";
import { StatusToggleSwitch } from "../StatusToggleSwitch";
import { projectCategoriesListingStatus } from "../../redux/features/mastersSlice";

export const ProjectCategoryListingStatus = ({ params }) => {
    return (
        <div>
            <StatusToggleSwitch
                initialValue={params.isListed}
                api={projectCategoriesListingStatus(params.categoryId)}
            />
        </div>
    );
};
